import angular from 'angular';
import { PeriodoDeApuracaoFormController } from './periodo-de-apuracao.form.controller';

export class PeriodoDeApuracaoFormComponent implements angular.IComponentOptions {
    static selector = 'periodoDeApuracaoFormComponent';
    static controller = PeriodoDeApuracaoFormController;
    static template = require('!!html-loader!./periodo-de-apuracao.form.html');
    static transclude = true;
    static bindings = {
        entity: '=',
        form: '<?',
        editable: '<',
    };
}
